import { createHashHistory, History } from 'history';
import { safeJsonParse } from 'utils';

export interface IHistory extends History {
  goBack: (backupPath?: string) => void;
}

const isLocationEqual = (location1: any, location2: any) => {
  return (
    location1.pathname === location2.pathname &&
    location1.search === location2.search &&
    location1.hash === location2.hash
  );
};

// 初始化时生成 Tab ID
const tabId = sessionStorage.getItem('tab_id') || Date.now().toString();
sessionStorage.setItem('tab_id', tabId);

// 路由栈
let routeStack = safeJsonParse<any[]>(sessionStorage.getItem(`route_stack_${tabId}`)) || [];
// 当前路由索引
let currentRouteIndex = Number(sessionStorage.getItem(`current_route_index_${tabId}`)) || 0;

const hashHistory: IHistory = createHashHistory();
const originGoBack = hashHistory.goBack;

if (!routeStack.find(location => isLocationEqual(hashHistory.location, location))) {
  console.log('initial route stack=>', routeStack, hashHistory.location);
  routeStack.push(hashHistory.location);
  currentRouteIndex = routeStack.length - 1;
  sessionStorage.setItem(`route_stack_${tabId}`, JSON.stringify(routeStack));
  sessionStorage.setItem(`current_route_index_${tabId}`, currentRouteIndex.toString());
}

hashHistory.listen((location, action) => {
  console.log('===hashHistory===', action, location);
  if (action === 'PUSH') {
    if (routeStack.length > 0) {
      // 如果当前路由和新路由相同，则不添加
      if (isLocationEqual(routeStack[currentRouteIndex], location)) return;
    }
    routeStack.push(location);
  } else if (action === 'REPLACE') {
    routeStack[currentRouteIndex] = location;
  } else if (action === 'POP') {
    // 根据当前路径查找路由栈中的位置
    const currentIndex = routeStack.findIndex(loca => isLocationEqual(loca, location));
    if (currentIndex >= 0) {
      if (currentIndex === currentRouteIndex - 1 || currentIndex === currentRouteIndex) {
        routeStack = routeStack.slice(0, currentIndex + 1); // 截断到当前位置
      } else {
        routeStack.push(location);
      }
    } else {
      routeStack.push(location);
    }
  }

  currentRouteIndex = routeStack.length - 1;
  // 存储时按 Tab 隔离
  sessionStorage.setItem(`route_stack_${tabId}`, JSON.stringify(routeStack));
  sessionStorage.setItem(`current_route_index_${tabId}`, currentRouteIndex.toString());
  console.log('routeStack', routeStack);
});

hashHistory.goBack = (backupPath?: string) => {
  // 有历史记录
  if (currentRouteIndex > 0 && routeStack.length > 1) {
    originGoBack();
  } else {
    // 无历史记录
    hashHistory.replace(backupPath || '/');
  }
};

window.addEventListener('beforeunload', e => {
  // 刷新时
  if (performance.navigation.type === 0) {
    // do nothing
  } else {
    // 退出系统或者窗口关闭
    sessionStorage.clear();
  }
});

export default hashHistory;
